export default __webpack_public_path__ + "static/media/404-not-found.33e4a6e8.png";